import './App.css';

function App() {
  return (
      <div className='bg-white vw-100 vh-100 justify-content-center d-flex  align-items-center text-center'>
      <i className='animation1 bi bi-whatsapp text-success' style={{fontSize:'50vh'}}></i>
      <div className=''>
        <div className='100vh 100vw border-2 text-dark fw-bold fs-1'>Basic 2 AI</div>
        <div className='100vh 100vw border-2 text-primary fs-3'>HMT Electric Vehicles</div>
        <a href='https://wa.me/14155238886?text=join%20sing-twenty' className='text-white btn btn-primary rounded-1'><i className='bi bi-whatsapp'></i> Chat Now</a>
      </div>  
      </div>
  );
}

export default App;
